import { render } from "./FormesSuperposees.vue?vue&type=template&id=55e7d4ea&scoped=true"
import script from "./FormesSuperposees.vue?vue&type=script&lang=js"
export * from "./FormesSuperposees.vue?vue&type=script&lang=js"

import "./FormesSuperposees.vue?vue&type=style&index=0&id=55e7d4ea&scoped=true&lang=css"

import exportComponent from "/Volumes/FITS/Projets-VueJs/montessori-app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55e7d4ea"]])

export default __exports__